import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components

import routes from "routes.js";

import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle.js";

import login from "assets/img/login-trn.jpeg";
import logo from "assets/img/logo.svg";
import lock from "assets/img/lock.jpeg";
import error from "assets/img/clint-mckoy.jpg";
import LoginPage from "views/Pages/LoginPage.js";
import LockScreenPage from "views/Pages/LockScreenPage.js";
import ErrorPage from "views/Pages/ErrorPage.js";
import Login from "views/Authen/Login";

const useStyles = makeStyles(styles);

export default function Pages(props) {
  // const { ...rest } = props;
  // ref for the wrapper div
  const wrapper = React.createRef();
  // styles
  const classes = useStyles();
  React.useEffect(() => {
    document.body.style.overflow = "unset";
    // Specify how to clean up after this effect:
    return function cleanup() {};
  });
  const getRoutes = (routes) => {
    return (
      <>
        <Route path="/auth/login" component={Login} key={0} />
        <Route
          path="/auth/lock-screen-page"
          component={LockScreenPage}
          key={1}
        />
        <Route path="/auth/error-page" component={ErrorPage} key={2} />
      </>
    );
  };
  const getBgImage = () => {
    if (window.location.pathname.indexOf("/auth/login") !== -1) {
      return login;
    } else if (
      window.location.pathname.indexOf("/auth/lock-screen-page") !== -1
    ) {
      return lock;
    } else if (window.location.pathname.indexOf("/auth/error-page") !== -1) {
      return error;
    }
  };
  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  return (
    <div>
      <div className={classes.wrapper} ref={wrapper}>
        <div
          className={classes.fullPage}
          style={{ backgroundImage: "url(" + getBgImage() + ")" }}
        >
          {window.location.pathname.indexOf("/auth/login") !== -1 && (
            <div
              style={{
                position: "absolute",
                top: 24,
                left: 32,
                zIndex: 5,
                display: "flex",
                alignItems: "center",
              }}
            >
              <img src={logo} alt="logo" style={{ height: 180 }} />
            </div>
          )}
          <Switch>
            {getRoutes(routes)}
            <Redirect from="/auth" to="/auth/login" />
          </Switch>
        </div>
      </div>
    </div>
  );
}
